var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hub"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:flex-col mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-1/5 mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Hub/Drop Point",
      "url": "/hub/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1), _c('div', {
    staticClass: "w-4/5 flex justify-end gap-8 mdmax:justify-start mdmax:w-full mdmax:flex-col mdmax:gap-2"
  }, [_c('div', {
    staticClass: "w-3/12 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Provinsi")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.provinces,
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedProvince,
      callback: function ($$v) {
        _vm.selectedProvince = $$v;
      },
      expression: "selectedProvince"
    }
  })], 1), _c('div', {
    staticClass: "w-3/12 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota/Wilayah")]), _c('CustomSelect', {
    staticClass: "select",
    attrs: {
      "options": _vm.cities,
      "optionLabel": "name",
      "enableSearch": true
    },
    on: {
      "search": _vm.doSearch
    },
    model: {
      value: _vm.selectedArea,
      callback: function ($$v) {
        _vm.selectedArea = $$v;
      },
      expression: "selectedArea"
    }
  })], 1), _c('div', {
    staticClass: "w-6/12 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Nama hub, wilayah, PIC, Kode Hub"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('LinkButton', {
          attrs: {
            "buttonText": "Lihat rincian",
            "url": `/hub/detail/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }) : column.field === 'primary_pic_name' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry.primary_pic_name) + " "), _c('span', {
          staticClass: "block text-sm text-neutral-500"
        }, [_vm._v(_vm._s(entry.primary_pic_phoneno))])]) : column.field === 'secondary_pic_name' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(entry.secondary_pic_name) + " "), _c('span', {
          staticClass: "block text-sm text-neutral-500"
        }, [_vm._v(_vm._s(entry.secondary_pic_phoneno))])]) : column.field === 'area_code' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm.getAreaName(entry.area_code)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v("Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }